export const SET_TOAST_SUCESSO = 'SET_TOAST_SUCESSO';
export const SET_TOAST_ERRO = 'SET_TOAST_ERRO';
export const SET_TOAST_INFO = 'SET_TOAST_INFO';

